import { designSystemColors } from '@klv/shared/styles/colors';

export const chart = {
  charcoal: {
    backgroundColor: designSystemColors.charcoal,
    textColor: designSystemColors.white,
  },
  lightSand: {
    backgroundColor: designSystemColors.lightSand,
    textColor: designSystemColors.charcoal,
  },
  white: {
    backgroundColor: designSystemColors.white,
    textColor: designSystemColors.charcoal,
  },
};

export default chart;
